import CryptoJSAES from 'crypto-js/aes';
import CryptoJSEncUtf8 from 'crypto-js/enc-utf8';

export const getDecryptedValue = value => {
  if (!value) {
    return undefined;
  }
  try {
    const decryptedValue = CryptoJSAES.decrypt(
      value,
      process.env.VUE_APP_LS_ENC_KEY
    ).toString(CryptoJSEncUtf8);
    return JSON.parse(decryptedValue);
  } catch (error) {
    // Undecryptable state is absent state, not an empty object. Ciphertext
    // written under a different VUE_APP_LS_ENC_KEY decrypts to '' and used to
    // surface as {}, which then went out as a GraphQL String variable —
    // "Expected a String input, but it was a 'LinkedHashMap'" — rejecting the
    // whole query and emptying the page it belonged to.
    return undefined;
  }
};

/**
 * Decrypt an OpenSSL-compatible payload ("Salted__" AES-256-CBC with
 * EVP_BytesToKey/MD5), which is how marvin-core ships encrypted GraphQL
 * attributes. crypto-js reads that layout natively, so this replaces the
 * aes-everywhere package — it declared grunt 0.4 and babel-core 6 as runtime
 * dependencies and was the sole source of every remaining critical advisory.
 */
export const decryptAttribute = (
  value,
  key = process.env.VUE_APP_GRAPHQL_ATTR_ENC_KEY
) => CryptoJSAES.decrypt(value, key).toString(CryptoJSEncUtf8);

export const getEncryptedValue = storeValue => {
  const json = JSON.stringify(storeValue);
  return CryptoJSAES.encrypt(json, process.env.VUE_APP_LS_ENC_KEY).toString();
};

export const storeEncryptedValue = (storeName, storeValue) => {
  const encrypted = getEncryptedValue(storeValue);
  window.localStorage.setItem(storeName, encrypted);
  return encrypted;
};
